import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m586-115-237-83-189 76q-10 3-20 2-9-2-17-7t-12-13q-5-8-5-19v-572q0-18 10-31 10-14 26-21l181-63 13-3 13-1 13 1 13 3 237 83 188-76q10-3 20-2 9 1 17 6t13 14q5 8 5 19v579q0 16-11 28-10 11-25 17l-181 63q-6 3-13 4l-13 1-13-1q-7-1-13-4Zm-8-86v-493l-196-66v493l196 66Zm60 0 137-45v-501l-137 53v493Zm-453-14 137-52v-493l-137 45v500Zm453-479v493-493Zm-316-66v493-493Z"/>',
  f: '<path d="m586-115-237-83-189 76q-10 3-20 2-9-2-17-7t-12-13q-5-8-5-19v-572q0-18 10-31 10-14 26-21l181-63 13-3 13-1 13 1 13 3 237 83 188-76q10-3 20-2 9 1 17 6t13 14q5 8 5 19v579q0 16-11 28-10 11-25 17l-181 63q-6 3-13 4l-13 1-13-1q-7-1-13-4Zm-8-86v-493l-196-66v493l196 66Z"/>',
};

export default data;
